'use client'

import { PrefetchKind } from '@repo/table/adapters/next'
import { useRouter } from 'next/navigation'

/**
 * Fully prefetches a route as soon as the pointer reaches its row or link. A details route's
 * layout fetches the record on the server, so the prefetch carries it and opening the row needs
 * no browser request for it. The router fetches a route it holds or is fetching only once.
 * Links that use it never prefetch on their own (`RowDetailsLink`, `PrefetchLink`).
 */
export const useHoverPrefetch = () => {
  const router = useRouter()

  return (href: string) => router.prefetch(href, { kind: PrefetchKind.FULL })
}
